import React from 'react'

import { BrowserRouter, Switch, Route } from 'react-router-dom'
import theme, { themeV5 } from 'material/theme'
import { RouterToUrlQuery } from 'react-url-query'
import { Provider } from 'react-redux'
import { ErrorBoundary } from '@scoir/error-reporter'
import { ThemeProvider } from '@material-ui/core/styles'
import { ThemeProvider as ThemeProviderV5 } from '@mui/material'
import { LicenseInfo } from '@mui/x-data-grid-pro'

import ErrorReporter from 'components/ErrorReporter'
import Login from './routes/Login'
import store from './store'
import AppStartup from './AppStartup'
import './bootstrap.scss'
import './App.scss'
import MUI_PRO_KEY from 'components/MuiPro/key'

class App extends React.Component {
  constructor() {
    super()
    LicenseInfo.setLicenseKey(MUI_PRO_KEY)
  }

  render() {
    const ROOT_PATH = import.meta.env.BASE_URL
    return (
      <ErrorReporter>
        <ErrorBoundary>
          <ThemeProviderV5 theme={themeV5}>
            <ThemeProvider theme={theme}>
              <BrowserRouter>
                <Provider store={store}>
                  <RouterToUrlQuery>
                    <Switch>
                      {import.meta.env.DEV && (
                        <Route
                          exact
                          path={`${ROOT_PATH}/login`}
                          component={Login}
                        />
                      )}
                      <Route
                        path={ROOT_PATH}
                        component={AppStartup}
                      />
                    </Switch>
                  </RouterToUrlQuery>
                </Provider>
              </BrowserRouter>
            </ThemeProvider>
          </ThemeProviderV5>
        </ErrorBoundary>
      </ErrorReporter>
    )
  }
}

export default App
